module.exports = __webpack_public_path__ + "static/media/rysunek-dom.3d9ba416.webp";